export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5180.9f8604f2.jpg";